/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineParseRequest {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineParseRequest.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineParseRequest>): AIUnitEconomicsBaselineParseRequest {
        let obj = Object.assign(new AIUnitEconomicsBaselineParseRequest(), model);
        AIUnitEconomicsBaselineParseRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineParseRequest>): AIUnitEconomicsBaselineParseRequest {
        if (!model) return null;
        return AIUnitEconomicsBaselineParseRequest.newInstance(<AIUnitEconomicsBaselineParseRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineParseRequest) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineParseRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineParseRequest): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineParseRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the uploaded file; its extension selects the reader (.xlsx or .csv)
     */
    file_name: string;

    /**
     * Base64-encoded file content. A 'data:' URL prefix is accepted
     */
    content: string;

    /**
     * Overrides the field used to identify entries. Defaults to the column named 'primary_key.<field>'
     */
    primary_key: string;

}
